import { motion } from "framer-motion";
import { Square } from "lucide-react";
import { ChatStore } from "@/stores/ChatStore";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export default function StopButton() {
  const { t } = useTranslation();
  const isRunning = ChatStore(state => state.isRunning);
  const setIsRunning = ChatStore(state => state.setIsRunning);
  const setAvatarStatus = ChatStore(state => state.setAvatarStatus);
  const setIsAvatarReady = ChatStore(state => state.setIsAvatarReady);

  const stop = () => {
    setIsRunning(false);
    setAvatarStatus("");
    setIsAvatarReady(false);
    console.log("Session ended");
  };

  if (!isRunning) return null;

  return (
    <motion.button
      onClick={stop}
      className={cn(
        "relative h-14 w-14 rounded-full border border-white bg-primary bg-red-500 text-white shadow-lg transition-colors duration-200 ease-in-out"
      )}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      aria-label={t('common.stop')}
      title={t('common.stop')}
    >
      <motion.div
        initial={false}
        animate={{
          scale: 1,
          opacity: 1,
        }}
        transition={{ duration: 0.2 }}
        className="absolute inset-0 flex items-center justify-center"
      >
        <Square className="h-6 w-6" strokeWidth={2} />
      </motion.div>
    </motion.button>
  );
}
